import { Tooltip } from "@appkit4/react-components";
import { Button, Select } from "../../../components/ReadonlyAwareInputs";
import sqldatabaseService from "../../../services/sqldatabase/sqldatabase.service";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const GroupSelector = ({
  selectedGroupName,
  isLoading,
  userGroupList,
  groupId,
  setSelectedGroupName,
  setGroupId,
  lockedGroup,
  isReadOnlyUser,
  isGroupLocked,
  nonReadonlyButtonTooltip,
  openSelectedGroup,
  dropdownsDisabled,
}) => {
  const buttonStyle = {
    width: "100%",
    height: "100%",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div className="row">
      <p className="col-3 text-vertical-center">Select an existing group:</p>
      <Select
        className="col"
        placeholder={selectedGroupName || "Dropdown"}
        disabled={isLoading || dropdownsDisabled}
        searchable
        data={getNamesFromList(userGroupList)}
        value={groupId}
        onSelect={async (groupName) => {
          let proceedCheck = true;
          if (lockedGroup && lockedGroup !== groupName) {
            try {
              const response =
                await sqldatabaseService.postRemoveGroupLock(lockedGroup);
              if (response.status !== 200) proceedCheck = false;
            } catch (err) {
              console.error("Error removing group lock:", err);
              proceedCheck = false;
            }
          }
          if (proceedCheck) {
            setSelectedGroupName(groupName);
            const val = getIdByName(groupName, userGroupList);
            setGroupId(val);
          }
        }}
      />
      <div
        className="col-4"
        style={{ padding: 0, display: "flex", gap: "10px" }}
      >
        <div style={{ flex: 1 }}>
          <Tooltip
            disabled={!(isGroupLocked || isReadOnlyUser)}
            content={nonReadonlyButtonTooltip}
            position="top-right"
          >
            <div style={{ height: "100%" }}>
              <Button
                style={buttonStyle}
                searchable
                loading={isLoading}
                disabled={
                  groupId?.length === 0 ||
                  isReadOnlyUser ||
                  isGroupLocked ||
                  dropdownsDisabled
                }
                onClick={() => openSelectedGroup(false)}
              >
                Edit group
              </Button>
            </div>
          </Tooltip>
        </div>
        <div style={{ flex: 1 }}>
          <Button
            style={buttonStyle}
            searchable
            loading={isLoading}
            disabled={groupId?.length === 0}
            onClick={() => openSelectedGroup(true)}
          >
            Open read-only
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GroupSelector;
